/**============================================================
*   [view] ToggleNavigation
*   description : カテゴリ切り替え（ラジオボタン用）
============================================================*/
<script>
import { reactive } from 'vue';
import ToggleOverlayAccordion from './ToggleOverlayAccordion.vue';
export default {
  name: 'ToggleNavigation',
  components: {
    ToggleOverlayAccordion,
  },
  setup() {
    const state = reactive({
      selectedCategory: 'all',
    })

    return {
      state,
    }
  },
}
</script>

